<template>
    <img :style="style" @click="$emit('click', $event)" v-if="isCustom" class="BaseIcon" :src="src" :class="`BaseIcon__size-${size}`">
    <v-icon v-else class="BaseIcon" v-bind="$attrs" v-on="$listeners">
        <slot />
    </v-icon>
</template>

<script>

const iconMap = {
    'add': 'add',
    'add_green': 'add_green',
    'add_circle': 'add_circle',
    // 'add': {
    //     name: 'close',
    //     style: 'transform: rotate(45deg)'
    // },
    // 'close': 'close',
    'arrow_left_white': 'arrow_left_white',
    'arrow_swap': 'arrow_swap',
    'arrow_swap_blue': 'arrow_swap_blue',
    'arrow_swap_circle_blue': 'arrow_swap_circle_blue',
    'arrow_right': 'arrow_right',
    'arrow_right_blue': 'arrow_right_blue',
    'briefcase': 'briefcase',
    'close': {
        name: 'add',
        style: 'transform: rotate(45deg)'
    },
    'check_filled': 'check_filled',
    'check_filled_white': 'check_filled_white',
    'check_filled_blue': 'check_filled_blue',
    'close_blue': 'close_blue',
    'chevron_down': 'chevron_down',
    'chevron_left': {
        name: 'chevron_down',
        style: 'transform: rotate(90deg)'
    },
    'chevron_right': {
        name: 'chevron_down',
        style: 'transform: rotate(-90deg)'
    },
    'chevron_down_filled': 'chevron_down_filled',
    'chevron_left_filled': {
        name: 'chevron_down_filled',
        style: 'transform: rotate(90deg)'
    },
    'chevron_right_filled': {
        name: 'chevron_down_filled',
        style: 'transform: rotate(-90deg)'
    },
    'close_circle': 'close_filled',
    'calendar': 'calendar',
    'calendar_green': 'calendar_green',
    'calendar_grey': 'calendar_grey',
    'contact_info': 'icon-contact-info',
    'date_range': 'date_range',
    'dialog_balloon': 'dialog_balloon',
    'document-request-accepted': 'document-request-accepted',
    'document-request-not-asked': 'document-request-not-asked',
    'document-request-pending': 'document-request-pending',
    'error_filled': 'error_filled',
    'euro_purse': 'euro_purse',
    'euro_purse_green': 'euro_purse_green',
    'envelope_square': 'envelope_square',
    'envelop': 'icon-menu-envelop',
    'filter': 'filter',
    'favorite_circle': 'favorite_circle',
    'favorite_heart': 'favorite_heart',
    'favorite_heart_empty': 'favorite_heart_empty',
    'facebook_square': 'facebook_square',
    'facebook_white': 'facebook',
    'facebook': 'icon-menu-facebook',
    'go_back': 'go_back',
    'go_back_filled': 'go_back_filled',
    'go_left': 'go_left',
    'go_left_green': 'go_left_green',
    'go_down': {
        name: 'go_left',
        style: 'transform: rotate(90deg)'
    },
    'go_right': {
        name: 'go_left',
        style: 'transform: rotate(180deg)'
    },
    'go_up': {
        name: 'go_left',
        style: 'transform: rotate(270deg)'
    },
    'gauge_red': 'gauge_red',
    'gauge_yellow': 'gauge_yellow',
    'gauge_orange': 'gauge_orange',
    'gauge_green': 'gauge_green',
    'help_filled': 'help_filled',
    'help_filled_blue': 'help_filled_blue',
    'helicoptere': 'helicoptere',
    'icon-check': 'icon_check',
    'icon_check_green': 'icon_check_green',
    'jet': 'jet',
    'leaf': 'leaf',
    'like_filled': 'like_filled',
    'like_unfilled': 'like_unfilled',
    'linkedin_square': 'linkedin_square',
    'linkedin': 'icon-menu-linkedin',
    'linkedin_white': 'linkedin',
    'marker': 'marker',
    'marker_large': 'marker_large',
    'marker_new': 'marker_new',
    'marker_new_large': 'marker_new_large',
    'marker_green_dark': 'marker_green_dark',
    'marker_green': 'marker_green',
    'marker_blue': 'marker_blue',
    'menu': 'menu',
    'menu_filled': 'menu_filled',
    'moon': 'moon',
    'nautics': 'nautics',
    'nautics_white': 'nautics_white',
    'operator': 'operator',
    'plane_left': 'plane_left',
    'plane_right': 'plane_right',
    'plane_solid': 'plane_solid',
    'passenger': 'passenger',
    'passenger_green': 'passenger_green',
    'passenger_grey': 'passenger_grey',
    'passenger_blue': 'passenger_blue',
    'piston': 'piston',
    'question_filled_primary': 'question_filled_primary',
    'question_filled': 'question_filled',
    'question_transparent': 'question_transparent',
    'rating_star_2third': 'rating_star_2third',
    'rating_star_third': 'rating_star_third',
    'rating_star_border': 'rating_star_border',
    'rating_star': 'rating_star',
    'rating_star_half': 'rating_star_half',
    'search': 'search',
    'search_secondary': 'search_secondary',
    'search_circle': 'search_circle',
    'speed': 'speed',
    'speed_green': 'speed_green',
    'speed_circle': 'speed',
    'safety': 'safety',
    'travel_time': 'travel_time',
    'triple_dots_secondary_outline': 'triple_dots_secondary_outline',
    'triple_dots_secondary_filled': 'triple_dots_secondary_filled',
    'triple_dots_primary_filled': 'triple_dots_primary_filled',
    'triple_dots_primary_outline': 'triple_dots_primary_outline',
    'triple_dots_primary_outline_horizontal': {
        name: 'triple_dots_primary_outline',
        style: 'transform: rotate(90deg)',
    },
    'twitter_square': 'twitter_square',
    'twitter': 'icon-menu-twitter',
    'twitter_white': 'twitter',
    'turboprop': 'turboprop',
    'user_blue': 'user_blue',
    'video_play': 'video_play',
    'weight': 'weight',
};
const srcSvgPath = '/webapp_assets/icons';

import { get } from 'lodash';
import { password } from '../validations';

export default {
    name: 'BaseIcon',

    props: {
        size: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            name: null,
            style: null,
        };
    },

    computed: {
        mappedName() {
            const value = iconMap[this.name];
            if (typeof value === 'object') {
                return value.name;
            } else {
                return value;
            }
        },
        isCustom() {
            return !!this.mappedName;
        },
        src() {
            return `${srcSvgPath}/${this.mappedName}.svg`;
        }
    },

    watch: {
        name: {
            handler(name) {
                const value = iconMap[name];
                if (typeof value === 'object' && value.style) {
                    this.style = value.style;
                } else {
                    this.style = null;
                }
            },
            immediate: true,
        }
    },

    created() {
        this.getName();    
    },

    updated() {
        this.getName();
    },

    methods: {
        getName() {
            this.name = get(this.$slots, 'default[0].text').trim();
        }
    }
};
</script>

<style lang="scss">
    @import '~webapp/styles/_variables';
    @import '~webapp/styles/_typography';

    @mixin size($size) {
        width: $size;
        height: $size;
    }

    p > .BaseIcon, span > .BaseIcon {
        vertical-align: middle;
    }

    .BaseIcon {
        font-size: inherit;
        color: inherit;
        justify-content: center;

        &.BaseIcon__size-normal {
            @include size($fs);
        }
        &.BaseIcon__size-xs {
            @include size($fs-xs);
        }
        &.BaseIcon__size-s {
            @include size($fs-s);
        }
        &.BaseIcon__size-sm {
            @include size($fs-sm);
        }
        &.BaseIcon__size-m {
            @include size($fs-m);
        }
        &.BaseIcon__size-l {
            @include size($fs-l);
        }
        &.BaseIcon__size-xl {
            @include size($fs-xl);
        }
        &.BaseIcon__size-xll {
            @include size($fs-xll);
        }
        &.BaseIcon__size-xxl {
            @include size($fs-xxl);
        }
        &.BaseIcon__size-xxxl {
            @include size($fs-xxxl);
        }
        &.BaseIcon__size-fill {
            @include size(100%);
        }
        &.BaseIcon__size-auto {
            @include size(auto);
        }
    }

</style>



// WEBPACK FOOTER //
// resources/webapp/components/BaseIcon.vue